import './Result.less'
import Result from './Result'

export type { ResultProps } from './iResult'

export default Result
